import React from 'react';

import { ThemeProvider } from '@alphonsocode/kallos';
import AsyncCreatableSelect from 'react-select/async-creatable';
import { SingleSelectDW } from './style';

export interface Option {
  value: string;
  label: string;
  path?: string;
}

const customStyles = {
  control: (base: any, state: any) => ({
    ...base,
    borderColor: state.isFocused ? '#006e7d' : '#c3ccd4',
    boxShadow: state.isFocused ? '0 0 0 1.5px #006e7d' : 'none',
    '&:hover': {
      borderColor: state.isFocused ? '#006e7d' : '#c3ccd4',
    },
  }),
  option: (base: any) => ({
    ...base,
    textAlign: 'left',
    fontWeight: 560,
  }),
  singleValue: (base: any) => ({
    ...base,
    textAlign: 'left',
    width: '100%',
    fontWeight: 560,
  }),
  input: (base: any) => ({
    ...base,
    textAlign: 'left',
    fontWeight: 560,
  }),
  placeholder: (base: any) => ({
    ...base,
    textAlign: 'left',
  }),
  menu: (base: any) => ({
    ...base,
    textAlign: 'left',
  }),
};

function CreatableSingleSelectDropdown({
  placeholder,
  value,
  loadOptions,
  onChange,
  defaultOptions,
  isLoading,
  setIsOpen,
  formatCreateLabel,
}) {
  const handleCreate = (inputValue: string) => {
    const newOption: Option = {
      value: inputValue,
      label: inputValue,
    };
    onChange(newOption);
  };

  return (
    <SingleSelectDW>
      <AsyncCreatableSelect<Option>
        className="singleSelectDW"
        value={value}
        loadOptions={loadOptions}
        onChange={onChange}
        onCreateOption={handleCreate}
        isSearchable
        cacheOptions
        isClearable
        placeholder={placeholder}
        loadingMessage={() => 'Searching...'}
        noOptionsMessage={({ inputValue }) =>
          inputValue ? `No Options` : 'No Options'
        }
        formatCreateLabel={
          formatCreateLabel || (inputValue => `Create "${inputValue}"`)
        }
        defaultOptions={defaultOptions.slice(0, 50).map(item => ({
          value: item.key,
          label: item.label,
        }))}
        styles={customStyles}
        isLoading={isLoading}
        captureMenuScroll={true}
        menuShouldScrollIntoView={true}
        onMenuOpen={() => setIsOpen(true)}
        onMenuClose={() => setIsOpen(false)}
      />
    </SingleSelectDW>
  );
}

export default CreatableSingleSelectDropdown;
